var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1621_289793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 16.332C12.0859 16.332 11.3359 17.082 11.3359 17.9987C11.3359 18.9154 12.0859 19.6654 13.0026 19.6654C13.9193 19.6654 14.6693 18.9154 14.6693 17.9987C14.6693 17.082 13.9193 16.332 13.0026 16.332ZM23.0026 16.332C22.0859 16.332 21.3359 17.082 21.3359 17.9987C21.3359 18.9154 22.0859 19.6654 23.0026 19.6654C23.9193 19.6654 24.6693 18.9154 24.6693 17.9987C24.6693 17.082 23.9193 16.332 23.0026 16.332ZM18.0026 16.332C17.0859 16.332 16.3359 17.082 16.3359 17.9987C16.3359 18.9154 17.0859 19.6654 18.0026 19.6654C18.9193 19.6654 19.6693 18.9154 19.6693 17.9987C19.6693 17.082 18.9193 16.332 18.0026 16.332Z",
    fill: "#2B2A28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1621_289793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDots);
export default __webpack_public_path__ + "static/media/more-dots.5390d1da2c46a8edd624f04e853f629d.svg";
export { ForwardRef as ReactComponent };